import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/finanza';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-68" data-mp="e3dirvkbfkrm">
      <div className="mx-auto max-w-6xl" data-id="element-69" data-mp="9mg9750515e">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-70" data-mp="58z49v7m0e9k">
          <div className="lg:col-span-7" data-id="element-71" data-mp="574iyfsfek4y">
            <p className="font-serif text-2xl italic leading-none text-[#1F9D6B]" data-id="element-72" data-mp="3mguja2sg8vy9">La differenza con FINANZA PRONTA™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-[#1E2B58] sm:text-6xl" data-id="element-73" data-mp="3rhi60c9naqmo">
              Dalle schede sparse a <em className="text-[#1F9D6B]" data-id="element-74" data-mp="3dir0he8umda5">un percorso già pronto.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-[#1E2B58]/75 lg:col-span-5" data-id="element-75" data-mp="3ihlpwz1bn038">
            Immagina di sapere già cosa fare ogni mese di educazione finanziaria. Hai la programmazione, la
            lezione minuto per minuto, la scheda in 3 livelli, il gioco con i soldi finti e la griglia di valutazione.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-[#1E2B58]/15 sm:grid-cols-3" data-id="element-76" data-mp="1faddhg08n4gq">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-[#1E2B58]/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-77" data-mp="1sznjmfe9qwbd" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-[#1E2B58]/70" data-id="element-78" data-mp="10brq1jjzxkit">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-[#1E2B58]" data-id="element-79" data-mp="wazhksiy7jnl">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-80" data-mp="1abii7el33nfq">
          <article className="rounded-3xl border border-[#1E2B58]/10 bg-stone-100 p-8 sm:p-11" data-id="element-81" data-mp="15be3nu3ql2s5">
            <p className="text-sm font-semibold text-[#1E2B58]/60" data-id="element-82" data-mp="2lpnqukw8slhe">Prima di FINANZA PRONTA™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-[#1E2B58]/80 sm:text-4xl" data-id="element-83" data-mp="2lrgwbwv4cznt">
              Ti riconosci?
            </h3>
            <ul className="mt-8 divide-y divide-[#1E2B58]/10 border-t border-[#1E2B58]/10" data-id="element-84" data-mp="2oq7dwyriuynt">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-[#1E2B58]/70" data-id="element-85" data-mp="2sr9djgpcpcqb">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-[#1E2B58]/40" aria-hidden="true" data-id="element-86" data-mp="2xsqbp4ggal37" />
                  <span data-id="element-87" data-mp="32q8oj5xl9kgh">
                    <span className="block font-semibold text-[#1E2B58]/80" data-id="element-88" data-mp="2539pwpnc62fy">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-[#1E2B58] p-8 text-stone-50 shadow-2xl shadow-[#1E2B58]/30 sm:p-11" data-id="element-89" data-mp="2f1phetq9zdpz">
            <p className="text-sm font-semibold text-[#F2B134]" data-id="element-90" data-mp="2jso205iaqxz1">Con FINANZA PRONTA™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-91" data-mp="1md1p4e73zo2x">
              Prepari meno. Insegni con serenità.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-92" data-mp="1raaa0mjn667v">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-93" data-mp="1jrkjcc8m0zxw">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#1F9D6B]" data-id="element-94" data-mp="1eu0xaq5o7ive">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-95" data-mp="14v39xqjzdvdz" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-[#1E2B58]/80 sm:text-3xl" data-id="element-96" data-mp="w318boy6e924">
          Concentrati sui tuoi alunni – non sul preparare tutto da solo.
        </p>
      </div>
    </section>;
}